import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '-1rem',
    marginRight: '-1rem',
    height: '500px',
    width: '480px',
    backgroundColor: 'white',
    cursor: 'default',

    [theme.breakpoints.down('sm')]: {
      width: 'auto',
      height: '100%'
    }
  },

  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },

  icon: {
    marginBottom: '24px'
  },

  title: {
    marginBottom: '8px',
    fontSize: theme.size.lg,
    color: '#1F1F1F'
  },

  subtitle: {
    fontSize: theme.size.base,
    color: '#1F1F1F'
  }
}))

export default useStyles
